// Footer.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';

function Footer() {
    let navigate = useNavigate();

    // Navigate to the FAQ page
    const handleFAQ = () => {
        navigate('/faq');
    };

    const handleTerms = () => {
        navigate('/terms');
    };

    const handlePrivacyPolicy = () => {
        navigate('/privacy-policy');
    };

    const emailAddress = "boostinterview.help@gmail.com";

    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-logo-and-name">
                    <a href="/" className="logo-link">
                        <img src="./favicon.svg" alt="Interview Prep Logo" className="footer-logo" />
                        <span className="website-name">Boost Interview</span>
                    </a>
                </div>
                <div className="footer-links">
                    <span className="footer-links">Copyright © 2024 Boost Interview</span>
                    <button onClick={handleFAQ}>FAQ</button>
                    <button onClick={() => window.location = `mailto:${emailAddress}`}>Contact us</button>
                    <button onClick={handlePrivacyPolicy}>Privacy Policy</button>
                    <button onClick={handleTerms}>Terms</button>
                    <a href="https://twitter.com/Boost_Interview" target="_blank" rel="noopener noreferrer" className="twitter-icon-link">
                        <img src="./twitter_logo.svg" alt="Twitter Logo" className="twitter-icon" />
                    </a>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
